/* Moved from layout__custom-code--head.liquid for HTML weight (SEO Test 10-15-26) */


/* === elevate-atc-oos-guard === */
(function () {
  if (window.__elevateAtcOosGuard) return;
  window.__elevateAtcOosGuard = true;

  var LABEL_OOS = 'Out of Stock';
  var variantsByNorm = Object.create(null); // normLabel -> { id, available, option1 }
  var variantsById = Object.create(null);
  var loaded = false;
  var savedBtnText = null;

  function norm(s) {
    return String(s || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  }

  /** Exact only — never substring (avoids T1B/27 ↔ 1 Black). */
  function lookupExact(label) {
    var n = norm(label);
    if (!n) return null;
    if (variantsByNorm[n]) return variantsByNorm[n];
    // Also try without spaces around slash: T1B / 27 → T1B/27
    var compact = n.replace(/\s*\/\s*/g, '/');
    if (compact !== n && variantsByNorm[compact]) return variantsByNorm[compact];
    return null;
  }

  function ingestProduct(p) {
    if (!p || !p.variants) return;
    variantsByNorm = Object.create(null);
    variantsById = Object.create(null);
    p.variants.forEach(function (v) {
      var opt = v.option1 || v.title || '';
      var rec = {
        id: String(v.id),
        available: !!v.available,
        option1: opt
      };
      variantsById[rec.id] = rec;
      var keys = [opt, v.title].filter(Boolean);
      keys.forEach(function (k) {
        var n = norm(k);
        variantsByNorm[n] = rec;
        variantsByNorm[n.replace(/\s*\/\s*/g, '/')] = rec;
      });
    });
    loaded = true;
  }

  function loadVariants() {
    if (loaded) return Promise.resolve();
    try {
      if (window.meta && meta.product && meta.product.variants && meta.product.variants.length && typeof meta.product.variants[0].available === 'boolean') {
        ingestProduct({ variants: meta.product.variants.map(function (v) {
          return {
            id: v.id,
            available: v.available,
            option1: (v.public_title || v.name || '').split(' / ')[0] || v.name,
            title: v.name
          };
        })});
        if (loaded) return Promise.resolve();
      }
    } catch (e) {}

    var path = location.pathname.replace(/\/$/, '');
    if (!/\/products\//.test(path)) return Promise.resolve();
    return fetch(path + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) ingestProduct(p); })
      .catch(function () {});
  }

  function selectedSwatchLabel() {
    var sel =
      document.querySelector('variant-swatch-king li.swatch-view-item:has(.swatch-selected)') ||
      document.querySelector('variant-swatch-king .swatch-selected') &&
        document.querySelector('variant-swatch-king .swatch-selected').closest('li.swatch-view-item');
    if (!sel) {
      // fallback: aria / checked
      sel = document.querySelector('variant-swatch-king li.swatch-view-item[aria-checked="true"], variant-swatch-king li.swatch-view-item.is-selected');
    }
    if (!sel) return '';
    var t =
      (sel.querySelector('.swatch-img-text-adjacent p') || {}).textContent ||
      (sel.querySelector('.swatch-img-text-adjacent') || {}).textContent ||
      sel.getAttribute('data-value') ||
      sel.getAttribute('data-option-value') ||
      sel.getAttribute('aria-label') ||
      sel.getAttribute('title') ||
      '';
    // aria often "T1B/27 - Sold Out" — take before " - "
    t = String(t).split(' - ')[0];
    return t.trim();
  }

  function idInputs() {
    return Array.prototype.slice.call(
      document.querySelectorAll('form[action*="/cart/add"] [name="id"], .shopify-product-form [name="id"], .product__page--info [name="id"]')
    );
  }

  function buyButtons() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.product__atc button[data-buy-button], form[action*="/cart/add"] button[data-buy-button]')
    );
  }

  function paymentBlocks() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.shopify-payment-button, .product__atc .shopify-payment-button')
    );
  }

  function setFormVariantId(id) {
    idInputs().forEach(function (el) {
      if (String(el.value) === String(id)) return;
      el.value = id;
      el.dispatchEvent(new Event('change', { bubbles: true }));
      el.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  function applyOosUi(isOos) {
    buyButtons().forEach(function (btn) {
      if (isOos) {
        if (savedBtnText == null) {
          var span = btn.querySelector('[data-button-text]');
          savedBtnText = span ? span.textContent : btn.textContent;
        }
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('data-elevate-oos', '1');
        var span2 = btn.querySelector('[data-button-text]');
        if (span2) span2.textContent = LABEL_OOS;
        else btn.textContent = LABEL_OOS;
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('data-elevate-oos');
        if (savedBtnText != null) {
          var span3 = btn.querySelector('[data-button-text]');
          if (span3) span3.textContent = savedBtnText;
          else btn.textContent = savedBtnText;
        }
      }
    });
    paymentBlocks().forEach(function (el) {
      if (isOos) el.setAttribute('data-elevate-oos', '1');
      else el.removeAttribute('data-elevate-oos');
    });
  }

  function sync() {
    if (!loaded) return;
    var label = selectedSwatchLabel();
    var rec = lookupExact(label);
    if (!rec) {
      // No exact swatch match — leave theme alone (don't force OOS).
      // es-own-swatch 2026-10-18: only undo what this guard set; never re-enable a button Booster disabled for a sold-out variant.
      if (document.querySelector('button[data-buy-button][data-elevate-oos]')) applyOosUi(false);
      return;
    }
    setFormVariantId(rec.id);
    applyOosUi(!rec.available);
  }

  function onSubmit(e) {
    if (!loaded) return;
    var label = selectedSwatchLabel();
    var rec = lookupExact(label);
    if (rec && !rec.available) {
      e.preventDefault();
      e.stopPropagation();
      applyOosUi(true);
      return false;
    }
    // If swatch says T1B/27 but form still has another id, force correct id or block
    if (rec && rec.available) {
      setFormVariantId(rec.id);
    }
    if (rec && !rec.available) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }

  function bind() {
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('variant-swatch-king li.swatch-view-item, variant-swatch-king .swatch-image-wrapper, variant-swatch-king label')) {
        setTimeout(sync, 0);
        setTimeout(sync, 50);
        setTimeout(sync, 200);
      }
      var btn = e.target.closest && e.target.closest('button[data-buy-button]');
      if (btn && btn.getAttribute('data-elevate-oos') === '1') {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') setTimeout(sync, 0);
    }, true);
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('variant:change', function () { setTimeout(sync, 0); });
  }

  loadVariants().then(function () {
    bind();
    sync();
    setTimeout(sync, 400);
    setTimeout(sync, 1200);
  });
})();


/* === elevate-shopify-pc-banner-js === */
(function () {
  var SHORT =
    'We use cookies to improve your experience, personalize content, and analyze traffic. ';
  var done = false;

  function shortenBody(dialog) {
    if (!dialog || dialog.getAttribute('data-elevate-short') === '1') return;
    var body = dialog.querySelector('.shopify-pc__banner__body') || dialog;
    var p = body.querySelector('p');
    if (!p) return;
    var link =
      body.querySelector('a.shopify-pc__banner__body-policy-link') ||
      body.querySelector('a[href*="privacy"]') ||
      p.querySelector('a');
    var href = (link && link.getAttribute('href')) || '/policies/privacy-policy';
    var target = link && link.getAttribute('target');
    var rel = link && link.getAttribute('rel');
    // Only replace text nodes inside p — keep structure minimal
    while (p.firstChild) p.removeChild(p.firstChild);
    p.appendChild(document.createTextNode(SHORT));
    var a = document.createElement('a');
    a.href = href;
    a.id = 'shopify-pc__banner__body-policy-link';
    a.className = 'shopify-pc__banner__body-policy-link';
    a.textContent = 'Privacy Policy';
    if (target) a.setAttribute('target', target);
    if (rel) a.setAttribute('rel', rel);
    p.appendChild(a);
    p.appendChild(document.createTextNode('.'));
    dialog.setAttribute('data-elevate-short', '1');
  }

  function run() {
    if (done) return;
    var dialog =
      document.querySelector('#shopify-pc__banner .shopify-pc__banner__dialog') ||
      document.querySelector('.shopify-pc__banner__dialog');
    if (!dialog) return;
    shortenBody(dialog);
    // Do not touch buttons or re-inject CSS that fights Shopify
    if (dialog.getAttribute('data-elevate-short') === '1') done = true;
  }

  run();
  document.addEventListener('DOMContentLoaded', run);
  /* speed-1019: batch DOM-change bursts into one check per frame (was one check per mutation batch) */
  var obsQ = false;
  var obs = new MutationObserver(function () {
    if (obsQ) return;
    obsQ = true;
    requestAnimationFrame(function () {
      obsQ = false;
      run();
      if (done) {
        try { obs.disconnect(); } catch (e) {}
      }
    });
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 15000);
})();


/* === elevate-consent-overlay-guard === */
/*
  Elevate Styles — consent overlay guard (Live+Test)
  Problem: Attentive #attentive_overlay z-index:2147483647 sits above Shopify
  Customer Privacy Accept and steals taps (Clarity mobile PDP error-tap #1).
  Fix: while #shopify-pc__banner is visible, mute Attentive; restore after Accept
  / banner dismiss. Optional clarity('consent') if theme-level clarity exists.
  Shopify App Clarity pixel still relies on Customer Privacy Accept signal.
*/
(function () {
  var BANNER_SEL = '#shopify-pc__banner, .shopify-pc__banner__dialog';
  var ATT_SEL = '#attentive_overlay, #attentive_creative, #attentive_crm_overlay, iframe#attentive_creative, [id^="attentive_"]';
  var open = false;

  function bannerVisible() {
    var nodes = document.querySelectorAll(BANNER_SEL);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var s = window.getComputedStyle(el);
      if (s.display === 'none' || s.visibility === 'hidden' || Number(s.opacity) === 0) continue;
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return true;
    }
    return false;
  }

  function muteAttentiveNodes(shouldMute) {
    document.querySelectorAll(ATT_SEL).forEach(function (el) {
      if (shouldMute) {
        el.style.setProperty('pointer-events', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
      } else {
        el.style.removeProperty('pointer-events');
        el.style.removeProperty('visibility');
      }
    });
  }

  function setOpen(next) {
    if (next === open) {
      if (next) muteAttentiveNodes(true);
      return;
    }
    open = next;
    try {
      document.body.classList.toggle('elevate-pc-banner-open', next);
    } catch (e) {}
    muteAttentiveNodes(next);
  }

  function sync() {
    setOpen(bannerVisible());
  }

  function signalClarityConsent() {
    return;
    try {
      if (typeof window.clarity !== 'function') return;
      try {
        window.clarity('consentv2', { ad_Storage: 'granted', analytics_Storage: 'granted' });
      } catch (e1) {}
      try {
        window.clarity('consent');
      } catch (e2) {}
    } catch (e) {}
  }

  function onConsentCollected(event) {
    try {
      var detail = event && (event.detail || event);
      var analytics =
        detail &&
        (detail.analyticsProcessingAllowed === true ||
          detail.analyticsAllowed === true ||
          (detail.customerPrivacy &&
            (detail.customerPrivacy.analyticsProcessingAllowed === true ||
              detail.customerPrivacy.analyticsAllowed === true)) ||
          detail.analytics === true ||
          detail.analytics === 'yes');
      if (analytics) signalClarityConsent();
    } catch (e) {}
    // Banner should dismiss shortly after Accept
    setTimeout(sync, 0);
    setTimeout(sync, 100);
    setTimeout(sync, 400);
    setTimeout(sync, 1000);
  }

  var privacyBound = false;
  function bindPrivacy() {
    if (privacyBound) return true;
    try {
      if (!window.Shopify || !Shopify.customerPrivacy) return false;
      if (typeof Shopify.customerPrivacy.subscribe === 'function') {
        Shopify.customerPrivacy.subscribe('visitorConsentCollected', onConsentCollected);
      }
      document.addEventListener('visitorConsentCollected', onConsentCollected);
      privacyBound = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  // Capture-phase click/pointerup: keep mute via sync after Accept/Decline.
  // Guard: if (!t || !t.closest) return — required (SVG/text nodes).
  function onBannerBtnInteract(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('#shopify-pc__banner__btn-accept, .shopify-pc__banner__btn-accept, #shopify-pc__banner__btn-decline, .shopify-pc__banner__btn-decline')) {
      setTimeout(sync, 0);
      setTimeout(sync, 100);
      setTimeout(sync, 400);
      setTimeout(function () {
        try {
          if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed && Shopify.customerPrivacy.analyticsProcessingAllowed()) {
            signalClarityConsent();
          }
        } catch (err) {}
      }, 300);
    }
  }
  document.addEventListener('click', onBannerBtnInteract, true);
  document.addEventListener('pointerup', onBannerBtnInteract, true);

  sync();
  document.addEventListener('DOMContentLoaded', sync);
  var tries = 0;
  var poll = setInterval(function () {
    sync();
    tries++;
    var bound = bindPrivacy();
    // Clear once customerPrivacy found (MutationObserver covers late Attentive),
    // or hard-stop after ~20s. Prior bug: bind success short-circuited ++tries so
    // clearInterval never ran and subscribe re-bound every 250ms forever.
    if (bound || tries > 80) {
      clearInterval(poll);
    }
  }, 250);

  try {
    /* speed-1019: was a full style+layout read on every DOM/attribute change anywhere on the page;
       now at most one check per 120 ms (Attentive still muted while the privacy banner shows). */
    var syncQ = false;
    new MutationObserver(function (l) {
      if (l && l.length && l.every(function (m) { return m.type === 'attributes' && (m.attributeName === 'aria-label' || m.attributeName === 'title'); })) return; /* speed-1020: ignore restock-button label churn */
      if (syncQ) return;
      syncQ = true;
      setTimeout(function () { syncQ = false; sync(); }, 120);
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true });
  } catch (e) {}
})();


/* === elevate-fs-bar-js === */
(function () {
  var THRESHOLD = 7999;
  var EXCLUDED_REGIONS = { AK: 1, HI: 1, PR: 1 };

  function rootPath() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  function moneyFromCents(cents) {
    var n = Math.max(0, cents) / 100;
    try {
      return new Intl.NumberFormat((window.Shopify && Shopify.locale) || 'en-US', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function eligibleSubtotal(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      var handle = ((item.handle || '') + '').toLowerCase();
      var title = ((item.product_title || item.title || '') + '').toLowerCase();
      if (handle.indexOf('navidium') !== -1) return;
      if (title.indexOf('shipping protection') !== -1) return;
      if (title.indexOf('navidium') !== -1) return;
      total += item.final_line_price != null ? item.final_line_price : item.line_price;
    });
    return total;
  }

  function paintFromCart(cart) {
    var bar = document.querySelector('[data-elevate-fs-bar]');
    if (!bar || bar.hidden) return eligibleSubtotal(cart);
    var textEl = bar.querySelector('[data-elevate-fs-text]');
    var fillEl = bar.querySelector('[data-elevate-fs-fill]');
    var list = bar.querySelector('[data-elevate-fs-upsell-list]');
    var threshold = parseInt(bar.getAttribute('data-threshold-cents'), 10) || THRESHOLD;
    var sub = eligibleSubtotal(cart);
    var pct = Math.max(0, Math.min(100, Math.round((sub / threshold) * 100)));
    bar.setAttribute('data-fs-sub-cents', String(sub));

    // Keep each upsell card's unlock label in sync with LIVE subtotal
    bar.querySelectorAll('[data-elevate-fs-upsell]').forEach(function (wrap) {
      wrap.setAttribute('data-fs-sub', String(sub));
      var select = wrap.querySelector('[data-elevate-fs-variant-select]');
      var opt = select ? select.options[select.selectedIndex] : null;
      var priceCents = opt ? (parseInt(opt.getAttribute('data-price-cents'), 10) || 0) : 0;
      if (!opt) {
        var btn = wrap.querySelector('[data-elevate-add-another]');
        // fallback: parse price text later; leave label generic
      }
      var unlocks = (sub + priceCents) >= threshold;
      var label = wrap.querySelector('[data-elevate-fs-upsell-label]');
      var btn = wrap.querySelector('[data-elevate-add-another]');
      var cta = unlocks ? 'Add & unlock' : 'Add another';
      if (label) label.textContent = unlocks ? 'Add another & unlock free shipping' : (label.getAttribute('data-es-fs-label') || 'Add another wig toward free shipping'); /* audit-1018: wording by product type */
      if (btn) {
        btn.setAttribute('data-original-text', cta);
        var t = btn.querySelector('[data-button-text]');
        if (t && !btn.disabled) t.textContent = cta;
      }
    });

    if (fillEl) fillEl.style.width = pct + '%';
    if (sub >= threshold) {
      bar.classList.add('is-complete');
      if (textEl) textEl.textContent = "You've unlocked free shipping";
      if (list) list.style.display = 'none';
    } else {
      bar.classList.remove('is-complete');
      if (textEl) {
        textEl.innerHTML = "You're <span class=\"elevate-fs-card__amount\">" + moneyFromCents(threshold - sub) + "</span> away";
      }
      if (list) list.style.display = '';
    }
    return sub;
  }

  function syncFromCart() {
    return fetch(rootPath() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        paintFromCart(cart);
        return cart;
      });
  }

  window.ElevateFs = { syncFromCart: syncFromCart, paintFromCart: paintFromCart };

  function applyGeoHide(bar, data) {
    var country = '';
    var province = '';
    if (data && data.detected_values && data.detected_values.country) {
      country = data.detected_values.country.handle || data.detected_values.country.iso_code || '';
      if (data.detected_values.country.province) {
        province = data.detected_values.country.province.code || data.detected_values.country.province.handle || '';
      }
    }
    if (window.Shopify && Shopify.country && !country) country = Shopify.country;
    country = String(country || '').toUpperCase();
    province = String(province || '').toUpperCase();
    if (!country) return;
    if (country === 'PR' || country !== 'US' || EXCLUDED_REGIONS[province]) {
      bar.hidden = true;
      bar.style.display = 'none';
    }
  }

  function syncUpsellFromSelect(select) {
    if (!select) return;
    var wrap = select.closest('[data-elevate-fs-upsell]');
    if (!wrap) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    var btn = wrap.querySelector('[data-elevate-add-another]');
    var priceEl = wrap.querySelector('[data-elevate-fs-price]');
    var img = wrap.querySelector('[data-elevate-fs-img]');
    var label = wrap.querySelector('[data-elevate-fs-upsell-label]');
    var variantId = parseInt(opt.value, 10);
    var priceCents = parseInt(opt.getAttribute('data-price-cents'), 10) || 0;
    var bar = document.querySelector('[data-elevate-fs-bar]');
    var sub = parseInt((bar && bar.getAttribute('data-fs-sub-cents')) || wrap.getAttribute('data-fs-sub') || '0', 10) || 0;
    var threshold = parseInt((bar && bar.getAttribute('data-threshold-cents')) || wrap.getAttribute('data-fs-threshold') || '7999', 10) || 7999;
    var unlocks = (sub + priceCents) >= threshold;

    if (btn) {
      var defaultId = btn.getAttribute('data-default-variant-id');
      var defaultKey = btn.getAttribute('data-default-line-key') || '';
      btn.setAttribute('data-variant-id', String(variantId));
      if (String(variantId) === String(defaultId)) btn.setAttribute('data-line-key', defaultKey);
      else btn.setAttribute('data-line-key', '');
      var cta = unlocks ? 'Add & unlock' : 'Add another';
      btn.setAttribute('data-original-text', cta);
      var t = btn.querySelector('[data-button-text]');
      if (t) t.textContent = cta;
    }
    if (priceEl) priceEl.textContent = '+ ' + (opt.getAttribute('data-price') || '');
    if (img && opt.getAttribute('data-image')) img.src = opt.getAttribute('data-image');
    if (label) label.textContent = unlocks ? 'Add another & unlock free shipping' : (label.getAttribute('data-es-fs-label') || 'Add another wig toward free shipping'); /* audit-1018: wording by product type */
  }

  function initElevateFs() {
    var bar = document.querySelector('[data-elevate-fs-bar]');
    if (!bar) return;
    syncFromCart().then(function () {
      return fetch(rootPath() + 'browsing_context_suggestions.json', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (data) { applyGeoHide(bar, data); });
    }).catch(function () {});
  }

  document.addEventListener('booster:cart:update', function () {
    syncFromCart().catch(function () {});
  });

  // Also catch direct qty button clicks as a safety net (mirror calculator)
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target && e.target.closest && e.target.closest('.quantity--input__button');
    if (!qtyBtn) return;
    setTimeout(function () {
      syncFromCart().then(function () {
        if (window.cartPage && typeof cartPage.updateCart === 'function') {
          return cartPage.updateCart().then(function () { return syncFromCart(); });
        }
      }).catch(function () {});
    }, 350);
  }, true);

  document.addEventListener('change', function (e) {
    var select = e.target && e.target.closest && e.target.closest('[data-elevate-fs-variant-select]');
    if (select) syncUpsellFromSelect(select);
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-elevate-add-another]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    var lineKey = btn.getAttribute('data-line-key') || '';
    var label = btn.querySelector('[data-button-text]');
    var original = btn.getAttribute('data-original-text') || 'Add another';
    var root = rootPath();

    btn.disabled = true;
    if (label) label.textContent = 'Adding…';

    var qtyInput = lineKey
      ? document.querySelector('.quantity--input__input[data-variant-id="' + CSS.escape(lineKey) + '"]')
      : null;

    function done() {
      return syncFromCart().then(function () {
        if (window.cartPage && typeof cartPage.updateCart === 'function') {
          return cartPage.updateCart().then(function () { return syncFromCart(); });
        }
      });
    }

    function bumpViaTheme() {
      if (!qtyInput) return Promise.reject(new Error('no qty input'));
      qtyInput.value = (parseInt(qtyInput.value, 10) || 0) + 1;
      if (window.cartPage && typeof cartPage.updateQuantity === 'function') {
        return Promise.resolve(cartPage.updateQuantity({ target: qtyInput })).then(done);
      }
      return Promise.reject(new Error('no cartPage'));
    }

    function bumpViaApi() {
      return fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = null;
          (cart.items || []).forEach(function (item) {
            if (lineKey && item.key === lineKey) line = item;
            else if (!line && (item.variant_id === variantId || item.id === variantId)) line = item;
          });
          if (line && String(line.variant_id) === String(variantId)) {
            return fetch(root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: (line.quantity || 1) + 1 })
            }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
          }
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
        })
        .then(function (res) {
          if (!res || !res.ok) throw new Error('api failed');
          if (res.j && res.j.status && res.j.message && Number(res.j.status) >= 400) throw new Error(res.j.message);
          if (window.BoosterTheme && BoosterTheme.events && BoosterTheme.events.trigger) {
            BoosterTheme.events.trigger('booster:cart:update', { trigger: 'elevate-add-another' });
          }
          return done();
        });
    }

    bumpViaTheme()
      .catch(function () { return bumpViaApi(); })
      .then(function () {
        btn.disabled = false;
        if (label) label.textContent = original;
      })
      .catch(function () {
        btn.disabled = false;
        if (label) label.textContent = original;
      });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initElevateFs);
  else initElevateFs();
})();


/* === anon === */
(function () {
  function syncFabForMobileNav() {
    var nav = document.getElementById('open-mobile-nav');
    var filters = document.getElementById('filterToggle');
    var open = !!((nav && nav.checked) || (filters && filters.checked));
    document.body.classList.toggle('elevate-fab--hide-for-nav', open);
    if (open) {
      var fab = document.getElementById('elevate-fab');
      if (fab) fab.classList.remove('is-open');
    }
  }
  function bind() {
    var nav = document.getElementById('open-mobile-nav');
    var filters = document.getElementById('filterToggle');
    if (nav && !nav.dataset.elevateNavFabBound) {
      nav.dataset.elevateNavFabBound = '1';
      nav.addEventListener('change', syncFabForMobileNav);
    }
    if (filters && !filters.dataset.elevateNavFabBound) {
      filters.dataset.elevateNavFabBound = '1';
      filters.addEventListener('change', syncFabForMobileNav);
    }
    syncFabForMobileNav();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();


/* === elevate-pdp-premium-polish-js === */
(function () {
  function rewriteDeliveryEstimateCopy(root) {
    if (!root) return;
    // Description line: "for delivery by" → "for estimated delivery by"
    var nodes = root.querySelectorAll('text-display, .essential-estimated-delivery-description, span, div');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el || el.children && el.children.length) continue;
      var t = (el.textContent || '').trim();
      if (/^delivery$/i.test(t) && el.previousElementSibling) {
        // lit splits words across text-display nodes: "... for / delivery / by ..."
        // Mark the word node; CSS/title handles step label. Soften via title attribute only.
        el.setAttribute('data-elevate-est', '1');
      }
    }
    // Prefer rewriting contiguous plain text if present
    var desc = root.querySelector('.essential-estimated-delivery-description');
    if (desc && !desc.dataset.elevateEstLabeled) {
      var html = desc.innerHTML;
      if (/for\s+delivery\s+by/i.test(desc.textContent || '')) {
        // Walk text-display nodes and insert "estimated" before the delivery word
        var texts = desc.querySelectorAll('text-display');
        for (var j = 0; j < texts.length; j++) {
          var tx = (texts[j].textContent || '').replace(/\u00a0/g, ' ').trim();
          if (/^delivery$/i.test(tx)) {
            texts[j].setAttribute('data-elevate-est-word', '1');
            // Ensure a real space even if ::before collapses in the app shadow/custom element
            try {
              if (!/^estimated\s/i.test(texts[j].textContent || '')) {
                texts[j].textContent = 'estimated delivery';
                texts[j].removeAttribute('data-elevate-est-word');
              }
            } catch (e) {}
            break;
          }
        }
        desc.dataset.elevateEstLabeled = '1';
      }
    }
  }

  function relabelNotifyButtons() {
    var btns = document.querySelectorAll(
      'button.restock-alerts-unselectable-variant-text, button.restock-alerts-notify-button.PRODUCT_PAGE-notify-button'
    );
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var t = (b.textContent || '').trim();
      if (/out of stock\?\s*click here/i.test(t) || t === '') {
        // Keep accessible name accurate even when CSS ::after shows the label
        b.setAttribute('aria-label', 'Out of stock? Get a restock alert');
        b.setAttribute('title', 'Sign up for a restock alert');
      }
    }
  }

  function fixGluedEstimatedDelivery(root) {
    if (!root) root = document;
    var walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walk.nextNode())) {
      var v = node.nodeValue;
      if (!v || v.indexOf('estimateddelivery') === -1) continue;
      node.nodeValue = v.replace(/estimateddelivery/gi, 'estimated delivery');
    }
  }
  function run() {
    var ee = document.querySelector('#essential-estimated-delivery-app-block, essential-estimated-delivery-app-block');
    rewriteDeliveryEstimateCopy(ee);
    fixGluedEstimatedDelivery(ee || document);
    relabelNotifyButtons();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  // Essential Estimated / BestPush hydrate late
  setTimeout(run, 800);
  setTimeout(run, 2000);
  setTimeout(run, 4500);
  try {
    /* speed-1019: one pass per 150 ms burst instead of a full-page text walk on every mutation batch */
    var moQ = false;
    var mo = new MutationObserver(function () {
      if (moQ) return;
      moQ = true;
      setTimeout(function () { moQ = false; run(); }, 150);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 12000);
  } catch (e) {}
})();


/* === elevate-mnav-parent-link-js === */
(function () {
  function bind(root) {
    if (!root) return;
    root.querySelectorAll('a.elevate-mnav__parent-link').forEach(function (a) {
      if (a.dataset.elevateParentBound) return;
      a.dataset.elevateParentBound = '1';
      a.addEventListener('click', function (e) {
        // Navigate to category; do not toggle the details accordion
        e.stopPropagation();
      });
    });
  }
  function run() {
    bind(document.querySelector('.mobile__navigation, .elevate-mobile-menu, [data-elevate-mnav], .header'));
    bind(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('a.elevate-mnav__parent-link');
    if (t) e.stopPropagation();
  }, true);
})();


/* === elevate-uk-ship-align === */
(function () {
  var isUk = false;
  try {
    var path = (location.pathname || '').toLowerCase();
    if (path.indexOf('/en-uk') === 0 || path.indexOf('/en-gb') === 0) isUk = true;
    var htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (htmlLang === 'en-gb' || htmlLang === 'en-uk') isUk = true;
    // Shopify localization cookie / meta
    var m = document.querySelector('meta[name="elevatestyles-country"], meta[property="og:locale"]');
    if (m && /gb|uk/i.test(m.getAttribute('content') || '')) isUk = true;
  } catch (e) {}
  // Liquid-rendered flag when present
  if (document.querySelector('[data-elevate-uk-ship]')) isUk = true;

  var UK_LINE = 'UK Shipping — flat £10 · 7–15 business days · Tracked delivery · Duties & taxes paid';
  var INTL_LINE = 'International / UK: 7–15 business days · Tracked · Duties & taxes paid (DDP) · UK from £10';

  function rewritePolicy() {
    var body = document.querySelector('.shopify-policy__body, .policy__body, .rte');
    if (!body) return;
    if (body.getAttribute('data-elevate-uk-aligned')) return;
    var html = body.innerHTML;
    // Fiddle ETA windows (theme-only; not Admin rates): USA Flat Rate/Free 2–7, Fast Ship 2–5
    html = html.replace(/Fast Ship Favorites:\s*1\s*[–-]\s*4 business days/gi,
      'Fast Ship Favorites: 2–5 business days');
    html = html.replace(/USA Orders:\s*1\s*[–-]\s*8 business days/gi,
      'USA Orders: 2–7 business days');
    html = html.replace(/USA Delivery:\s*2\s*[–-]\s*6 Business Days/gi,
      'USA Delivery: 2–7 Business Days');
    // Align international timing + insert UK Passport reality
    html = html.replace(/International Orders:\s*Delivered in 7\s*[–-]\s*12 business days/gi,
      'International / UK Orders: 7–15 business days · Duties & taxes paid (DDP)');
    html = html.replace(/International Orders:\s*Delivered in 6\s*[–-]\s*12 business days/gi,
      'International / UK Orders: 7–15 business days · Duties & taxes paid (DDP)');
    html = html.replace(/Fast Ship Favorites:\s*1\s*[–-]\s*4 business days/gi,
      'Fast Ship Favorites: 2–5 business days');
    html = html.replace(/USA Orders:\s*1\s*[–-]\s*8 business days/gi,
      'USA Orders: 2–7 business days');
    html = html.replace(/USA Delivery:\s*2\s*[–-]\s*6 Business Days/gi,
      'USA Delivery: 2–7 Business Days');

    if (isUk && html.indexOf('UK Shipping — flat') === -1) {
      html = html.replace(
        /(📢\s*Shipping Information|Shipping Information)/i,
        '$1<br><strong>' + UK_LINE + '</strong>'
      );
    }
    body.innerHTML = html;
    body.setAttribute('data-elevate-uk-aligned', '1');
  }

  function injectPdpNote() {
    if (!isUk) return;
    if (document.querySelector('[data-elevate-uk-ship]')) return;
    var host = document.querySelector('.product__page--info .product__atc, .shopify-product-form .product__atc, .product__atc');
    if (!host) return;
    var el = document.createElement('div');
    el.className = 'elevate-uk-ship-note';
    el.setAttribute('data-elevate-uk-ship', '1');
    el.innerHTML = '<strong>UK Shipping</strong> — flat £10 · 7–15 business days · Tracked delivery · Duties &amp; taxes paid';
    host.parentNode.insertBefore(el, host);
  }

  function run() {
    if (/\/policies\/shipping/.test(location.pathname)) rewritePolicy();
    if (isUk && (document.body.className.indexOf('template--product') !== -1 || document.body.classList.contains('template-product'))) injectPdpNote();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  setTimeout(run, 800);
  setTimeout(run, 2000);
})();


/* === elevate-oos-body-flag === */
/* Toggle body.elevate-variant-oos from ATC / selected sold-out swatch (live). Presentation CSS uses this. */
(function () {
  function isSoldOutUi() {
    var btn = document.querySelector(
      '.product__page--info .product__atc button[data-buy-button], .shopify-product-form .product__atc button[data-buy-button], .product__atc button[data-buy-button]'
    );
    if (btn) {
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.getAttribute('data-elevate-oos') === '1') return true;
      var t = ((btn.textContent || '') + ' ' + (btn.getAttribute('aria-label') || '')).toLowerCase();
      if (/sold out|out of stock|unavailable/.test(t)) return true;
    }
    var sw = document.querySelector(
      '.product__page--info .swatch-view-item.is-selected.swatch-item-unavailable, .product__page--info .swatch-view-item[aria-checked="true"].swatch-item-unavailable, variant-swatch-king .swatch-view-item.is-selected.swatch-item-unavailable'
    );
    if (sw) return true;
    return false;
  }
  function sync() {
    try { document.body.classList.toggle('elevate-variant-oos', isSoldOutUi()); } catch (e) {}
  }
  function boot() {
    sync();
    document.addEventListener('change', sync, true);
    document.addEventListener('click', function () { setTimeout(sync, 50); setTimeout(sync, 250); }, true);
    try {
      /* speed-1019: one check per frame instead of per mutation batch */
      var oosQ = false;
      var obs = new MutationObserver(function () {
        if (oosQ) return;
        oosQ = true;
        requestAnimationFrame(function () { oosQ = false; sync(); });
      });
      obs.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'class', 'aria-disabled', 'aria-checked', 'data-elevate-oos'] });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();


/* === elevate-search-cols-js === */
(function () {
  var PIN = { re: /human\s*hair/i, title: "Human Hair Wig", path: "/collections/human-hair-wig" };

  function fetchCols(q) {
    var url = "/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=collection&resources[limit]=6";
    return fetch(url).then(function (r) { return r.json(); }).then(function (data) {
      var cols = (((data || {}).resources || {}).results || {}).collections || [];
      var items = cols.map(function (c) { return { title: c.title, url: c.url }; });
      var pinned = items.find(function (i) { return i.url.indexOf(PIN.path) !== -1; });
      if (PIN.re.test(q)) {
        if (!pinned) items.unshift({ title: PIN.title, url: PIN.path });
        else items = [pinned].concat(items.filter(function (i) { return i !== pinned; }));
      }
      return items.slice(0, 4);
    }).catch(function () { return []; });
  }

  function block(items, page) {
    var wrap = document.createElement("div");
    wrap.className = "elevate-search-cols col-12";
    wrap.setAttribute(page ? "data-elevate-search-cols-page" : "data-elevate-search-cols", "");
    var label = document.createElement("p");
    label.className = "elevate-search-cols__label";
    label.textContent = "Collections";
    wrap.appendChild(label);
    items.forEach(function (item) {
      var a = document.createElement("a");
      a.href = item.url;
      a.textContent = item.title;
      wrap.appendChild(a);
    });
    return wrap;
  }

  function paintSuggest() {
    document.querySelectorAll("[data-search-container]").forEach(function (parent) {
      var input = parent.querySelector("input[data-search]");
      var box = parent.querySelector("[data-search-suggest]");
      if (!input || !box) return;
      var q = (input.value || "").trim();
      var existing = box.querySelector("[data-elevate-search-cols]");
      if (q.length < 2) {
        if (existing) existing.remove();
        return;
      }
      if (existing && box.getAttribute("data-elevate-cols-q") === q) return;
      box.setAttribute("data-elevate-cols-q", q);
      fetchCols(q).then(function (items) {
        if ((input.value || "").trim() !== q) return;
        var old = box.querySelector("[data-elevate-search-cols]");
        if (old) old.remove();
        if (!items.length) return;
        box.insertBefore(block(items, false), box.firstChild);
      });
    });
  }

  document.addEventListener("booster:initialized", function (e) {
    var theme = e.detail && e.detail.BoosterTheme;
    if (!theme || !theme.events || !theme.events.on) return;
    theme.events.on("booster:content:update", paintSuggest);
  });

  function paintPage() {
    if (!/\/search\/?$/.test(location.pathname)) return;
    var q = ((new URLSearchParams(location.search).get("q")) || "").trim();
    if (q.length < 2 || document.querySelector("[data-elevate-search-cols-page]")) return;
    fetchCols(q).then(function (items) {
      if (!items.length) return;
      var title = document.querySelector(".searchpage__title");
      if (!title || document.querySelector("[data-elevate-search-cols-page]")) return;
      title.parentNode.insertBefore(block(items, true), title);
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", paintPage);
  else paintPage();
})();
